import CreateWalletTemp from "../templates/CreateWalletTemp";

export const CreateWallet = () => <CreateWalletTemp />;